import { MediaRole, MediaViewConfig } from "./types";

export const MEDIA_CONFIGS: Record<MediaRole, MediaViewConfig> = {
  admin: {
    layout: "grid",
    showUploader: true,
    showApprovalStatus: true,
    showActions: true,
    enableBulkActions: false, // Not needed for partners
    enableFilters: true,
    enableSearch: true,
    maxFileSize: 100 * 1024 * 1024, // 100MB
    allowedFileTypes: ["image/jpeg", "image/png"], // Only JPEG and PNG allowed
  },

  contractor: {
    layout: "grid",
    showUploader: false, // Don't show uploader name for own files
    showApprovalStatus: true,
    showActions: true,
    enableBulkActions: false, // Not needed for partners
    enableFilters: false,
    enableSearch: true,
    maxFileSize: 50 * 1024 * 1024, // 50MB
    allowedFileTypes: ["image/jpeg", "image/png"], // Only JPEG and PNG allowed
  },

  partner: {
    layout: "grid",
    showUploader: true,
    showApprovalStatus: false, // Partners only see approved content
    showActions: false,
    enableBulkActions: false, // Not needed for partners
    enableFilters: true,
    enableSearch: true,
    allowedFileTypes: ["image/jpeg", "image/png"], // Only JPEG and PNG allowed
  },
};

export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// Max files can be configured via environment variable for testing
// Default is 5000, but can be lowered for testing (e.g., NEXT_PUBLIC_MAX_UPLOAD_FILES=100)
const getMaxUploadFiles = () => {
  if (
    typeof window !== "undefined" &&
    process.env.NEXT_PUBLIC_MAX_UPLOAD_FILES
  ) {
    const parsed = parseInt(process.env.NEXT_PUBLIC_MAX_UPLOAD_FILES, 10);
    if (!isNaN(parsed) && parsed > 0) {
      return parsed;
    }
  }
  return 5000; // Default max files
};

export const UPLOAD_SETTINGS = {
  maxFiles: getMaxUploadFiles(),
  maxFileSize: 100 * 1024 * 1024, // 100MB
  allowedTypes: [
    "image/jpeg",
    "image/jpg", // Some systems report .jpg with this MIME type
    "image/png",
  ],
  thumbnailSize: 300,
  batchSize: 1500,
  maxConcurrentUploads: 100,
  maxConcurrentBatches: 3, // Allow up to 3 batches in parallel
};

export const STORAGE_BUCKETS = {
  public: "fbc_events_public",
  media: process.env.AWS_S3_BUCKET || "fb-swoop-media",
} as const;
